'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
type ControlBarActionTooltipProps = {
  children: ReactElement;
  contentClassName?: string;
  label: string;
  portalContainer?: HTMLElement | null;
};
export default function ControlBarActionTooltip(t0) {
  const $ = _c(11);
  const {
    children,
    contentClassName,
    label,
    portalContainer
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TooltipTrigger asChild={true}><span className="inline-flex">{children}</span></TooltipTrigger>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== contentClassName) {
    t2 = cn("bg-vive-primary-70 text-vive-primary-20 rounded-sm", contentClassName);
    $[2] = contentClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== portalContainer || $[6] !== t2) {
    t3 = <TooltipContent side="top" sideOffset={8} portalContainer={portalContainer} className={t2}>{label}</TooltipContent>;
    $[4] = label;
    $[5] = portalContainer;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <Tooltip>{t1}{t3}</Tooltip>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}